import { apiRequest } from "../utils/Helpers";
import appConfig from "../../config/config.dev";

export function doListSeismicApps() {
    return apiRequest<Array<{ authEnv: string; name: string; distributionLink: string; }>>(`${appConfig.API_URL}/seismic/apps`);
}